<template>
    <div>
    	<table class="room-table" cellspacing="0">
            <thead>
                <tr>
                    <td>日</td>
                    <td>一</td>
                    <td>二</td>
                    <td>三</td>
                    <td>四</td>
                    <td>五</td>
                    <td>六</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="week in tableData" style="text-align: left;">
                    <td :class="getDaysSize(today,day.PD)>=0?(day.S=='026001'?'change-room':'change-room close'):'before-day' " v-for="day in week" @click="toRoomStatusSingleEdit(day)" >
                        <!-- <i></i> -->
                        <div v-if="day">
                            <i v-if="getDaysSize(today,day.PD)>=0&&day.S!='026001'&&day.S" ></i>
                            <p  v-if="day.A">
                                <label  v-if="day.S=='026001'" class="font12">开启 /</label>
                                <label  v-if="day.S&&day.S!='026001'" class="color-red font12">冻结 /</label>
                                <span style="color: #a48cfd;"> R </span>
                                <label  v-if="day.O==false&&day.O!=null" class="font12"> / 不可超售</label>
                                <span class="one font12"  v-if="day.O"> / 可超售</span>
                            </p>
                            <p  v-if="!day.A">
                                <label  v-if="day.S=='026001'" class="font12">开启 /</label>
                                <label  v-if="day.S&&day.S!='026001'" class="color-red font12">冻结 /</label>
                                <label class="size" v-show="day.SC!=null">{{day.SC?day.SC:0}}</label>
                                <label  v-if="day.O==false&&day.O!=null" class="font12"> / 不可超售</label>
                                <span class="one font12" v-if="day.O"> / 可超售</span>
                            </p>
                            <p>
                                <label> {{day.AP}}</label>
                            </p>
                           
                            <p v-show="!day.C">
                                <label v-show="day.CD!=null" class="font12">{{day.CD>0?'提前'+day.CD +'天':'当天'}}</label>
                                <label v-show="day.CT" class="font12">{{day.CT}}前取消</label>
                            </p>
                            <p v-show="day.C" ><span class="font12">不可取消</span></p>
                            <span class="day">{{getDateDay(day.PD)}}</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
 
    </div>

</template>
<script>


export default {
    name:'datePriceTable',

    props:{
        date: {
            type: String,
            default:''
        },
        rps:{
            type:Object,
            default:function(){
                return{}
            }
        }
    },
    data(){
        return{
            cmRps:{},
            tableData:'',
            cmDate: '',
            cmSingleData: {},
            today:this.getDate(0)
        }
    },
    watch:{
        date(val){
           
            this.cmDate=val+'01';
            this.initTable();

        },
        rps(val){
            this.cmRps=val;
            this.initTable();
        }
    },
    methods:{
        //获取月份的数据
        initTable(){
            
            var that=this;
            var cmRps=that.cmRps;
            var params={
              hotel: cmRps.HotelId,
              room: cmRps.RoomId,
              rp: cmRps.RatePlanId,
              rate: cmRps.RateId,
              date: that.cmDate,
            }
            that.isLoading = true;
            that.getRequest({
                url: that.Api.getRp,
                params: params
            }).then(res => {
                that.isLoading = false;
                if (res && res.length>0) {
                   that.toConfigTableData(res);//处理表格日期数据                  
                } else {
                    that.tableData='';
                    that.error({ title: '提示', content: '没有查询到相关数据' });
                }
            });
        },

        //将数据格式化表格日期格式
        toConfigTableData(data){
            var data=data;
            var weekday=this.getWeekday(data[0].PD);
            for(var i=0;i<weekday;i++){
                 data.unshift('');
            }
            var result = [];
            //补全日期前几天
            for(var i=0,len=data.length;i<len;i+=7){
               result.push(data.slice(i,i+7));
            }
            //补全日期后几天
            var length=result[(result.length-1)].length;
            if(length<7){
                for(var i=0;i<(7-length);i++){
                    result[(result.length-1)].push('');
                }
            }
            
            this.tableData=result;
           
    

        },
        //获取日期中的天
        getDateDay(date){
            var date=date;
            var day=date.split('/')[2];
            return day

        },
        //编辑单独一天的房态
        toRoomStatusSingleEdit(day){
            if(this.getDaysSize(this.today,day.PD)<0)return;//先判断当期日期是否可以编辑
            this.cmSingleData=day;
            this.$nextTick(function () {
                this.$set(this.cmSingleData,'isShow',this.cmSingleData.isShow?false:true);
    　　　　 });



        }
    },
    mounted(){
        this.cmRps=this.rps;
        this.cmDate=String(this.date)+'01';
        
        this.initTable();
    }

}
</script>












// WEBPACK FOOTER //
// src/components/RoomPriceAndStatus/psComponent/table.vue